// extracted by mini-css-extract-plugin
module.exports = {"theComp":"Smoothly_theComp__csZY0"};